import { TAG_STYLE } from 'transfix-ui/components/Tag'
import { ICarrierCallListMatchStrategyEnum } from 'types/graphqlTypes'

export enum CarrierStatus {
  activated = 'activated',
  new = 'new',
  pending = 'pending',
  applicationSubmitted = 'application_submitted',
  inReview = 'in_review',
  expiredInsurance = 'expired_insurance',
  outOfService = 'out_of_service',
  conditional = 'conditional',
  cancelled = 'cancelled',
  other = 'other',
  probation = 'probation',
  doNotUse = 'do_not_use',
  inactive = 'inactive',
}

export const MATCH_LABELS: Record<ICarrierCallListMatchStrategyEnum, string> = {
  [ICarrierCallListMatchStrategyEnum.posted_truck]: 'Posted',
  [ICarrierCallListMatchStrategyEnum.reserved_loads]: 'Reserved Loads',
  [ICarrierCallListMatchStrategyEnum.reload]: 'Reload',
  [ICarrierCallListMatchStrategyEnum.ran_backhaul]: 'Ran Backhaul',
  [ICarrierCallListMatchStrategyEnum.ran_headhaul]: 'Ran Headhaul',
  [ICarrierCallListMatchStrategyEnum.ran_before]: 'Ran Before',
  [ICarrierCallListMatchStrategyEnum.lane_alert]: 'Lane Alert',
  [ICarrierCallListMatchStrategyEnum.bid]: 'Bid',
  [ICarrierCallListMatchStrategyEnum.posts_often]: 'Posts Often',
  [ICarrierCallListMatchStrategyEnum.searched]: 'Searched',
}

export const MATCH_STYLES: Record<ICarrierCallListMatchStrategyEnum, TAG_STYLE> = {
  [ICarrierCallListMatchStrategyEnum.posted_truck]: TAG_STYLE.spruceGreen,
  [ICarrierCallListMatchStrategyEnum.reserved_loads]: TAG_STYLE.accentRed,
  [ICarrierCallListMatchStrategyEnum.reload]: TAG_STYLE.plumPurple,
  [ICarrierCallListMatchStrategyEnum.ran_backhaul]: TAG_STYLE.accentBlue,
  [ICarrierCallListMatchStrategyEnum.ran_headhaul]: TAG_STYLE.accentBlue,
  [ICarrierCallListMatchStrategyEnum.ran_before]: TAG_STYLE.accentBlue,
  [ICarrierCallListMatchStrategyEnum.lane_alert]: TAG_STYLE.accentRed,
  [ICarrierCallListMatchStrategyEnum.bid]: TAG_STYLE.accentBlue,
  [ICarrierCallListMatchStrategyEnum.posts_often]: TAG_STYLE.accentGreen,
  [ICarrierCallListMatchStrategyEnum.searched]: TAG_STYLE.accentGreen,
}

export type TMatchLabels = typeof MATCH_LABELS

export type TMatchStyles = typeof MATCH_STYLES

export type TCarrierStatus =
  | 'activated'
  | 'new'
  | 'pending'
  | 'application_submitted'
  | 'in_review'
  | 'expired_insurance'
  | 'out_of_service'
  | 'conditional'
  | 'cancelled'
  | 'other'
  | 'probation'
  | 'do_not_use'
  | 'inactive'
